const copyDiscountCode = async (button) => {
  const container = button.closest('[data-md-discount-copy]');
  const status = container?.querySelector('[role="status"]');
  const code = button.dataset.code;

  if (!status || !code) return;

  try {
    await navigator.clipboard.writeText(code);
    status.textContent = 'Código copiado. Pégalo en el campo de descuento antes de pagar.';
    button.textContent = 'Copiado';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'md_cart_welcome10_copy' });
  } catch (error) {
    status.textContent = 'Copia manualmente el código WELCOME10.';
  }
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-md-copy-discount]');
  if (!button) return;
  copyDiscountCode(button);
});
